var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"13","height":"13","viewBox":"0 0 13 13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"x":"0.5","y":"0.5","width":"12","height":"12","rx":"1.5","stroke":"#2F71F2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }